import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

import Login from './pages/Login';
import TicketListPage from './pages/TicketListPage';
import ForgotPassword from './pages/ForgotPassword';
import PrivateRoute from './utils/PrivateRoute';
import Profile from './pages/Profile';
import Dashboard from './pages/Dashboard';
import Timesheet from './pages/Timesheet';
import EmployeeDetails from './pages/employee_details';
import HrmsDashboard from './pages/HrmsDashboard';
import Org from './pages/Org';
import './styles/datepicker.css';

function App() {
  return (
    <Router>
      <Toaster position="top-right" />

      <Routes>
        {/* Show login page at root URL */}
        <Route path="/" element={<Login />} />

        <Route path="/forgot-password" element={<ForgotPassword />} />

        {/* HRMS Dashboard - Home */}
        <Route
          path="/home"
          element={
            <PrivateRoute>
              <HrmsDashboard />
            </PrivateRoute>
          }
        />

      {/* <Route
          path="/hrms"
          element={
            <PrivateRoute>
              <HrmsDashboard />
            </PrivateRoute>
          }
        /> */}

        <Route
          path="/org"
          element={
            <PrivateRoute>
              <Org />
            </PrivateRoute>
          }
        />

        {/* Protected Routes */}
        <Route
          path="/tickets"
          element={
            <PrivateRoute>
              <TicketListPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/tickets/:ticketId"
          element={
            <PrivateRoute>
              <TicketListPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />

        <Route
          path="/timesheet"
          element={
            <PrivateRoute>
              <Timesheet />
            </PrivateRoute>
          }
        />

        <Route
          path="/Dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/employee-details"
          element={
            <PrivateRoute>
              <EmployeeDetails />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
